import { createAction, props } from '@ngrx/store';

export const toggleMenu = createAction('[Navbar Component] Toggle Menu Avatar');

export const switchSelect = createAction('[Navbar Component] Switch the content to show in select page',
  props<{ selectContentType: string }>()
);
